export const TRANSLATIONS = {
    EN: {
        PROCESS: {
            ACTIONS: {
                CREATE_QUOTE: 'Create quote',
                SKIPPED_QUOTE: 'Skip quote',
                UPDATED_IDENTIFICATION: 'Update identification',
                RETURNED_CONFIRM_DISCUSSION: 'Back to discuss the concept deed',
                RETURNED_FINALIZE_DEED: 'Return to finalize deed',
                SKIPPED_FEEDBACK: 'Skip feedback',
                CANCELLED_APPLICATION: 'Cancel application',
                SKIPPED_PAYMENT: 'Skip payment',
                ADDED_SHAREHOLDER: 'Edit shareholders',
                ADDED_DIRECTOR: 'Edit directors',
                REMOVED_DIRECTOR: 'Delete director',
                REJECTED_TAXES: 'Decline document',
                SKIPPED_IDENTIFICATION: 'Skip identification',
                CANCELLED: 'Terminate process',
                CANCELLED_V1: 'Terminate process',
                CANCELLED_PROCESS: 'Terminate process',
                REFUNDED_CLIENT: 'Partial refund',
                PENDING: 'Resume process',
                PAUSED: 'Pause process',
                SKIPPED_UPLOAD_CONCEPT: 'Skip to uploading final deed',
                RESTARTED_IDENTIFICATION: 'Restart identification',
                SUBMITTED_EXTRA_PAYMENT: 'Extra payment',
                STARTED_SIGNING: 'Start digital signing',
                CANCELLED_EXTRA_PAYMENT: 'Cancel extra payment',
                UPDATED_UBO_INFO: 'Edit UBOs',
                REQUESTED_DOCUMENTS: 'Request documents',
                CANCELLED_REQUEST_DOCUMENTS: 'Cancel documents request',
                REQUESTED_CLIENT_INFORMATION: 'Request information from client',
                HANDLED_CLIENT_INFORMATION: 'Client has been spoken to',
                CANCELLED_REQUEST_INFORMATION: 'Withdraw information request',
                REQUEST_INTERVIEW: 'Schedule appointment',
                SKIPPED_VERIFY_ORGANIZATION: 'Skip requested documents',
                SKIPPED_VERIFY_CLIENT: 'Skip total verification',
                CANCELLED_COMPLETE_JOB: 'Add another quote',
                UPLOADED_SIGNING_DOCUMENT: 'Sign document',
                REVIEW_JOB: 'Confirmed result',
                CHANGED_SCENARIO: 'Change scenario',
                CHANGED_NOTARY: 'Change notary',
                CHANGED_SERVICE_PROVIDER: 'Change service provider',
                COMPLETED_INCORPORATION: 'Register incorporation',
                UPDATED_LEADS: 'Update leads',
                SEND_DOCUMENTS_NOBILEX: 'Send documents to Nobilex',
                CREATE_NOBILEX_DOSSIER: 'Create Nobilex dossier',
                CREATE_DAMSTE_DOSSIER: 'Create dossier in Next Assyst',
                SEND_DOCUMENTS_DAMSTE: 'Send documents to Next Assyst',
                RESTART_GW: 'Restart process',
                RESTART_INCORPORATION: 'Restart process',
                UNLINKED_SUB_PROCESS: 'Unlink sub process',
                LINKED_SUB_PROCESS: 'Link sub process',
                CHANGED_CLIENT: 'Change client',
                CHANGED_URGENCY: 'Change urgency',
                REQUESTED_FORM: 'Request information with form',
                CONVERTED_TO_GW: 'Converted to GW',
                SUBMITTED_INITIAL_OFFER: 'Create initial offer',
                RECHECK_SUB_PROCESS: 'Recheck the sub processes',
                TOOLTIP: {
                    REQUEST_INTERVIEW: {
                        CALENDLY_URL:
                            'To schedule an appointment you will need to configure your calendly url. You can configure it in your Account Settings. Contact {appName} if you require help with this: {phone}.',
                    },
                },
            },
        },
    },
    NL: {
        PROCESS: {
            ACTIONS: {
                CREATE_QUOTE: 'Offerte opstellen',
                SKIPPED_QUOTE: 'Offerte overslaan',
                UPDATED_IDENTIFICATION: 'Identificatie bijwerken',
                RETURNED_CONFIRM_DISCUSSION: 'Terug naar bespreek concept akte',
                RETURNED_FINALIZE_DEED: 'Keer terug om de finale akte te uploaden',
                SKIPPED_FEEDBACK: 'Feedback overslaan',
                CANCELLED_APPLICATION: 'Cancel application',
                SKIPPED_PAYMENT: 'Betaling overslaan',
                ADDED_SHAREHOLDER: 'Aandeelhouders bewerken',
                ADDED_DIRECTOR: 'Bestuurders bewerken',
                REMOVED_DIRECTOR: 'Bestuurder verwijderen',
                REJECTED_TAXES: 'Weigeren documenten',
                SKIPPED_IDENTIFICATION: 'Identificatie overslaan',
                CANCELLED: 'Beëindig proces',
                CANCELLED_V1: 'Beëindig proces',
                CANCELLED_PROCESS: 'Beëindig proces',
                REFUNDED_CLIENT: 'Gedeeltelijke refund',
                PENDING: 'Proces hervatten',
                PAUSED: 'Pauzeer procedure',
                SKIPPED_UPLOAD_CONCEPT: 'Spring naar finale akte uploaden',
                RESTARTED_IDENTIFICATION: 'Herstart identificatie',
                SUBMITTED_EXTRA_PAYMENT: 'Extra betaling',
                STARTED_SIGNING: 'Digitaal ondertekenen starten',
                CANCELLED_EXTRA_PAYMENT: 'Extra betaling annuleren',
                UPDATED_UBO_INFO: "UBO's bijwerken",
                REQUESTED_DOCUMENTS: 'Documenten aanvragen',
                CANCELLED_REQUEST_DOCUMENTS: 'Documenten aanvraag annuleren',
                REQUESTED_CLIENT_INFORMATION: 'Informatie opvragen bij client',
                HANDLED_CLIENT_INFORMATION: 'Client is gesproken',
                CANCELLED_REQUEST_INFORMATION: 'Informatieverzoek intrekken',
                REQUEST_INTERVIEW: 'Afspraak plannen',
                SKIPPED_VERIFY_ORGANIZATION: 'Opgevraagde documenten overslaan',
                SKIPPED_VERIFY_CLIENT: 'Totale verificatie overslaan',
                CANCELLED_COMPLETE_JOB: 'Nog een offerte maken',
                UPLOADED_SIGNING_DOCUMENT: 'Onderteken document',
                REVIEW_JOB: 'Bevestigd resultaat',
                CHANGED_SCENARIO: 'Scenario wijzigen',
                CHANGED_NOTARY: 'Notaris wijzigen',
                CHANGED_SERVICE_PROVIDER: 'Verander van dienstverlener',
                COMPLETED_INCORPORATION: 'Registreer oprichting',
                UPDATED_LEADS: 'Leads bijwerken',
                SEND_DOCUMENTS_NOBILEX: 'Stuur stukken naar Nobilex',
                CREATE_NOBILEX_DOSSIER: 'Maak Nobilex dossier aan',
                CREATE_DAMSTE_DOSSIER: 'Maak dossier in Next Assyst',
                SEND_DOCUMENTS_DAMSTE: 'Stuur stukken naar Next Assyst',
                RESTART_GW: 'Herstart process',
                RESTART_INCORPORATION: 'Herstart process',
                UNLINKED_SUB_PROCESS: 'Ontkoppel sub process',
                LINKED_SUB_PROCESS: 'Koppel sub process',
                CHANGED_CLIENT: 'Klant wijzigen',
                CHANGED_URGENCY: 'Urgentie wijzigen',
                REQUESTED_FORM: 'Informatie opvragen met formulier',
                CONVERTED_TO_GW: 'Omzetten naar GW',
                SUBMITTED_INITIAL_OFFER: 'Maak initiële offerte',
                RECHECK_SUB_PROCESS: 'Controleer de subprocessen',
                TOOLTIP: {
                    REQUEST_INTERVIEW: {
                        CALENDLY_URL:
                            'Om een afspraak te plannen dient u uw calendly url te configureren. U kunt deze configureren in uw account settings. Neem contact op met {appName} als assitentie nodig heeft: {phone}.',
                    },
                },
            },
        },
    },
};
